import { Link } from 'react-router-dom';
import { HugeiconsIcon } from '@hugeicons/react';
import { File01Icon } from '@hugeicons/core-free-icons';

function LoanSearch({ loan }) {
    return (
        <Link
            to={`/${loan?.state}/${loan?._id}`}
            className='flex items-center gap-4 px-4 py-3 border border-gray-100 rounded-lg hover:bg-gray-50 hover:border-gray-200 transition-colors'
        >
            <div className='w-8 h-8 rounded-lg bg-blue-50 flex items-center justify-center shrink-0'>
                <HugeiconsIcon icon={File01Icon} size={16} className='text-blue-600' />
            </div>
            <div className='flex-1 min-w-0'>
                <p className='text-sm font-medium text-gray-900 truncate'>
                    {loan?.client?.otherNames} {loan?.client?.surname}
                </p>
                <p className='text-xs text-gray-500'>{loan?.phone} · {loan?.type}</p>
            </div>
            {loan?.daysInDelinq >= 1 && (
                <span className='shrink-0 inline-flex items-center rounded-full bg-red-50 px-2.5 py-1 text-xs font-medium text-red-700 ring-1 ring-inset ring-red-600/10'>
                    {loan?.daysInDelinq}d arrears
                </span>
            )}
        </Link>
    );
}

export default LoanSearch;
